import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getEstadoRequisas = async() => {
    const result = await PrivateInterceptor(`Global/EstadoRequisa`, 'GET')
    return result;
}